import React, { useCallback } from "react";
import MessageBox from "meconversation/MessageBox";

interface AddOTSCommentProps {
  handleMessageDataChange: (data: any) => void;
  postEventData: any;
  handleActiveHeader: (data: any) => void;
  handleTwilioMessageSent: (twilioResponse: any) => void;
  handlePublicAttachmentCount: (count: number) => void;
  userData: any;
  handleFilesArrayChange?: (fileArray: File[]) => void;
}

const AddOTSComment: React.FC<AddOTSCommentProps> = React.memo(({
  handleMessageDataChange,
  postEventData,
  handleActiveHeader,
  handleTwilioMessageSent,
  handlePublicAttachmentCount,
  userData,
  handleFilesArrayChange
}) => {
  const onMessageDataChange = useCallback((data: any) => {
    handleMessageDataChange(data);
  }, [handleMessageDataChange]);

  const onActiveBoxHeader = useCallback((data: any) => {
    handleActiveHeader(data);
  }, [handleActiveHeader]);

  const onTwilioMessageSent = useCallback((twilioResponse: any) => {
    handleTwilioMessageSent(twilioResponse);
  }, [handleTwilioMessageSent]);

  const onPublicAttachmentAdd = useCallback((count: number) => {
    handlePublicAttachmentCount(count);
  }, [handlePublicAttachmentCount]);

  const onFilesArrayChange = useCallback((files: any) => {
    if(handleFilesArrayChange) handleFilesArrayChange(files);
  }, [handleFilesArrayChange]);

  return (
    <MessageBox
      onMessageDataChange={onMessageDataChange}
      eventData={postEventData}
      resetBox={true}
      activeBoxHeader={onActiveBoxHeader}
      onTwilioMessageSent={onTwilioMessageSent}
      hiddenHeader={{ hideBoth: false, hideNote: true }}
      createPost={true}
      onPublicAttachmentAdd={onPublicAttachmentAdd}
      userData={userData}
      onFilesArrayChange={onFilesArrayChange}
    />
  );
});

AddOTSComment.displayName = 'AddOTSComment';

export default AddOTSComment;